<div class="fixed top-6 right-6 z-50 flex flex-col gap-3 bg-blue-500">
  <div
    *ngFor="let toast of toasts()"
    class="group relative flex items-start gap-3 px-5 py-4 rounded-2xl shadow-2xl backdrop-blur-md border border-white/10 text-white animate-toast-slide-in overflow-hidden"
    [ngClass]="{
      'bg-gradient-to-r from-green-500/80 to-emerald-600/70': toast.type === 'success',
      'bg-gradient-to-r from-rose-500/80 to-red-600/70': toast.type === 'error',
      'bg-gradient-to-r from-amber-400/80 to-yellow-500/70': toast.type === 'warning',
      'bg-gradient-to-r from-blue-500/80 to-indigo-600/70': toast.type === 'info'
    }"
  >
    <!-- Icon -->
    <mat-icon fontIcon="{{ getIcon(toast.type) }}" class="text-2xl mt-0.5"></mat-icon>

    <!-- Message -->
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium leading-snug break-words">{{ toast.message }}</p>

      <!-- Animated Progress Bar -->
      <div class="mt-2 h-1 w-full bg-white/30 rounded-full overflow-hidden">
        <div
          class="h-full bg-white/80 animate-toast-progress"
          [style.animation-duration]="(toast.duration || 3000) + 'ms'"
        ></div>
      </div>
    </div>

    <!-- Close Button -->
    <button
      (click)="remove(toast.id)"
      class="text-white opacity-70 hover:opacity-100 transition-opacity"
    >
      <mat-icon fontIcon="close"></mat-icon>
    </button>
  </div>
</div>
